import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { extractStylesToArray, isSafe } from "@insite/client-framework/Common/Utilities/isSafeStyles";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@tecumseh/Store/Data/CustomApplicationState/CustomApplicationState";
import { COLORS } from "@tecumseh/theme/design";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    content = "content",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.content]: string;
    };
}

export interface DiscontinuedBanneStyles {
    wrapper?: InjectableCss;
    buttonWrapper?: InjectableCss;
    closeButtonIconProps?: IconPresentationProps;
}

const discontinuedBanneStyles: DiscontinuedBanneStyles = {
    wrapper: {
        css: css`
            float: left;
            padding: 14px;
            width: 90%;
        `
    },
    buttonWrapper: {
        css: css`
            float: right;
            margin: 12px 18px;
            cursor: pointer;
            top: 0;
            right: 0;
            position: absolute;
        `
    },
};

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        page: getCurrentPage(state),
        replacementProduct: state.TECData.replaceProductDetail
    }
}
const styles = discontinuedBanneStyles;
type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps>;
const DiscontinuedBanner: React.FunctionComponent<Props> = ({ fields, product, replacementProduct }) => {
    const { replacementProdctResult } = replacementProduct;
    const [isShowBanner, setIsShowBanner] = React.useState(!!false);
    const discontinuedStyle: InjectableCss = {
        css: css`
            width: 100%;
            min-height: 50px;
            color: #FFFFFF;
            position: relative;
            background-color: ${COLORS.alertMsgRed};
            p {
                font-size: 14px !important;
            }
        `,
    };
    const closeBtnHandler = () => {
        setIsShowBanner(true);
        if (window) {
            localStorage?.setItem("discontinued-banner", replacementProdctResult?.id);
        }
    }
    
    React.useEffect(() => {
        return () => {
            if (window) {
                // localStorage?.setItem("discontinued-banner", "");
            }
        }
    })
    if(isShowBanner || fields.content === "") {
        return null
    }
    if(!(product?.properties.isDiscontinued) ||
        product?.properties.isDiscontinued !== "true" ||
        window?.localStorage.getItem("discontinued-banner") === replacementProdctResult?.id
    ) {
        return null;
    }

    return (
        <StyledWrapper {...discontinuedStyle} id="discontinued-banner">
            <StyledWrapper {...styles.wrapper}>
                {parse(fields.content, parserOptions)}
            </StyledWrapper>
            <StyledWrapper {...styles.buttonWrapper} onClick={closeBtnHandler}>
                <svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </StyledWrapper>
        </StyledWrapper>
    )
}
const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(DiscontinuedBanner)),
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
                tab: basicTab,
            }
        ],
    },
};

export default widgetModule;
